import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'iho-custom-masonry',
  templateUrl: './custom-masonry.component.html',
  styleUrls: ['./custom-masonry.component.scss']
})
export class CustomMasonryComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() reviewsCount: number = 0;
  // ---
  @Input() columnCount: number = 4;
  // ---
  @Input() colClass: number = 3;
  // ---
  constructor() { }

  ngOnInit(): void {

  }


  /**
   * @description filter data and create custom data for showing in ui
   * @author Alireza PhF
   */
  filterData(): void {

  }

}
